// General Get function. accepts an  api endpoint, success callback(data), and optional error callback(error). Fetches the data and runs success or error
const abortControllers = new Map(); 

export function apiGet(endpoint, successCallback, errorCallback) {
    const defaultErrorCallback = (err) => console.error(err);
    const noSuccessCallback = (data) =>
        console.error(`No callback passed for ${endpoint}`, data);
    const newEndpoint = endpoint.slice(1, endpoint.length);

    // Abort any previous request for this endpoint
    if (abortControllers.has(endpoint)) {
        abortControllers.get(endpoint).abort();
    }

    const controller = new AbortController();
    const { signal } = controller;
    abortControllers.set(endpoint, controller);

    fetch(`/api/${newEndpoint}`, { signal, credentials: "include" })
        .then((r) => {
            if (r.ok) {
                return r.json();
            } else {
                throw new Error(`${r.status} ${r.statusText}`);
            }
        })
        .then(successCallback || noSuccessCallback)
        .catch((err) => {
            if (err.name === "AbortError") {
                console.error(`Request to ${endpoint} was aborted.`);
            } else {
                (errorCallback || defaultErrorCallback)(err);
            }
        })
        .finally(() => {
            abortControllers.delete(endpoint); 
        });
}